import { apiClient } from '../../api-client';
import formatDate from './formatDate';

// creation of tempo worklogs is only available on prod
export const createTempoWorklog = (getToken, email, from, to, type) => {
  if (import.meta.env.VITE_ENV === 'prod') {
    const worklogData = {
      userEmail: email,
      from: formatDate(from, 'yyyy-MM-dd'),
      to: formatDate(to, 'yyyy-MM-dd'),
      type,
    };

    apiClient('POST', '/tempo/worklog', getToken, worklogData);
  }
};
